import axios, { Axios } from "axios";
import { json } from "react-router-dom";
import axiosInstance from "src/hooks/axios-interceptor";

//ASSET
export const prepareItemData = (data) => {
  const body = {
    active: data.active,
    alarm: data.alarm,
    asset: {
      id: data.assetData.id,
      name: data.assetData.name,
    },
    building: {
      id: data.assetData.buildingId,
    },
    itemDescription: data.itemDescription,
    itemProtocol: "",
    itemType: {
      id: data.itemType.id,
      name: data.itemType.name,
    },
    serialNumber: data.serialNumber,
    thresholdCritical: data.thresholdCritical,
    thresholdHigh: data.thresholdHigh,
    thresholdLow: data.thresholdLow,
    thresholdMedium: data.thresholdMedium,
  };
  return body;
};

export const updateItemData = (data) => {
  const body = {
    active: data.active,
    alarm: data.alarm,
    id: data.id,
    itemDescription: data.itemDescription,
    itemProtocol: "",
    itemType: {
      id: data.itemType.id,
      name: data.itemType.name,
    },
    serialNumber: data.serialNumber,
    thresholdCritical: data.thresholdCritical,
    thresholdHigh: data.thresholdHigh,
    thresholdLow: data.thresholdLow,
    thresholdMedium: data.thresholdMedium,
  };
  return body;
};

export const Createitem = (body) => {
  return axiosInstance
    .post(`/createNewItem`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const UpdateItem = (body) => {
  return axiosInstance
    .put(`/item/${body.id}`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
      return response;
    });
};

export const deleteItem = (id) => {
  return axiosInstance
    .delete(`/item/${id}`)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getItem = (id) => {
  return axiosInstance
    .get(`/item/${id}`)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAllItems = () => {
  return axiosInstance
    .get(`/getAllItems`)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getitemsbyAsset = (id) => {
  return axiosInstance
    .get(`/item/getAllItemsByAsset/${id}`)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getEmailsOperators = (id) => {
  return axiosInstance
    .get(`/mntOperator/getMntOperatorsByAsset/${id}`)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

//private methods

const catchAxiosError = (error) => {
  if (!error.response) {
    // network error
    return json(
      {},
      {
        status: 404,
      }
    );
  } else {
    const code = error.response.status;
    const message = error.message;
    return { errors: [message] };
  }
};
